module.exports = __webpack_public_path__ + "img/undraw_Order_confirmed_re_g0if.b90542b2.png";